module.exports = __webpack_public_path__ + "static/img/顶部banner.1ebfcb7.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/顶部banner.gif
// module id = cjPI
// module chunks = 3